import React from 'react'
import Props from 'prop-types'
import { withProps } from 'recompose'

import config from 'config'
import IconAppStore from './IconAppStore'
import IconGooglePlay from './IconGooglePlay'
import { Button } from './styled'

const DownloadButton = ({ type, inverted, isGoogle, IconComponent }) => (
  <Button
    as="a"
    inverted={inverted}
    href={isGoogle ? config.googlePlayLink : config.appStoreLink}
    target="_blank"
  >
    <IconComponent />
    {type === 'google' ? 'Google Play' : 'App Store'}
  </Button>
)

DownloadButton.propTypes = {
  IconComponent: Props.any.isRequired,
  inverted: Props.bool,
  isGoogle: Props.bool.isRequired,
  type: Props.string.isRequired,
}

DownloadButton.defaultProps = {
  inverted: false,
}

export default withProps(props => ({
  IconComponent: props.type === 'google' ? IconGooglePlay : IconAppStore,
  isGoogle: props.type === 'google',
}))(DownloadButton)
